<template>
  <!-- Теги блюда: все теги пользователя чипами, выбранные залиты. Набор
       тегов правится в «Настройках Дневника», здесь — только отметить. -->
  <div v-if="store.enabled && store.tags.length" class="dish-tags">
    <span class="dish-tags-label">Теги</span>
    <button
      v-for="tag in store.tags" :key="tag" type="button"
      class="dish-tag" :class="{ on: modelValue.includes(tag) }" :aria-pressed="modelValue.includes(tag)"
      @click.stop="toggle(tag)"
    >{{ tag }}</button>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useFavTagsStore } from '../store/favTags.js'

const props = defineProps({ modelValue: { type: Array, default: () => [] } })
const emit = defineEmits(['update:modelValue'])
const store = useFavTagsStore()
onMounted(() => store.load())

function toggle(tag) {
  emit('update:modelValue', props.modelValue.includes(tag)
    ? props.modelValue.filter(t => t !== tag)
    : [...props.modelValue, tag])
}
</script>

<style scoped>
.dish-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.dish-tags-label {
  font-family: Inter, sans-serif;
  font-size: var(--fs-13);
  color: var(--ink-70);
  margin-right: 2px;
}
.dish-tag {
  height: 28px;
  padding: 0 11px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid var(--line);
  color: var(--ink);
  font-family: Inter, sans-serif;
  font-size: var(--fs-12);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s, border-color 0.15s, transform 0.1s;
}
.dish-tag:active { transform: scale(0.96); }
.dish-tag.on {
  background: var(--ink);
  border-color: var(--ink);
  color: var(--cream);
  font-weight: 600;
}
</style>
